import { useEffect, useMemo, useState, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { alarmStateFamily, alarmsState, silenceStateFamily } from '../../plugins/recoil';

let globalReminderStarted = false;
const useAlarm = (bedData, bedInfo, isPlayer) => {
    const [alarms, setAlarms] = useRecoilState(alarmsState);
    const [alarmPriorities, setAlarmPriorities] = useState({});
    // 병동 알람 상태(On=0, Suspend=1, Silence=2)

    useEffect(() => {
        if (bedData) {
            if (bedData.alarmData) {
                const parsedAlarmMessage = bedData.alarmData.map(item => { return { type: item.eventPriority, message: item.eventMessage, startTime: item.startTime } })

                const alarmList = []
                parsedAlarmMessage.sort((a, b) => b.type - a.type)
                parsedAlarmMessage.forEach((msgObj, idx) => {
                    alarmList.push({
                        id: `player-alarm-${idx}`,
                        message: msgObj.message,
                        type: msgObj.type === 2 ? 'High' : msgObj.type === 1 ? 'Medium' : 'Low',
                        startTime: msgObj.startTime,
                    })
                })
                // 알람 상태 업데이트
                setAlarms(prevAlarms => {
                    const resultAlarms = {
                        ...prevAlarms,
                    }
                    resultAlarms['player'] = alarmList
                    return resultAlarms
                });
                // 가장 높은 우선순위 계산
            } else {
                setAlarms(prevAlarms => {
                    const resultAlarms = { ...prevAlarms }
                    resultAlarms['player'] = []
                    return resultAlarms
                })
                setAlarmPriorities({})
            }
        }
    }, [bedData.alarmData]);

    return {
        alarms,
        alarmPriorities,
    };
};

export default useAlarm;
